import { motion } from 'framer-motion'
import { Button } from '../ui/Button'
import { SectionLabel } from '../ui/SectionLabel'
import { GridBackground } from '../background/GridBackground'

export function Hero() {
  return (
    <section
      className="relative flex flex-col justify-center overflow-hidden"
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: 'var(--bg)',
        minHeight: '100vh',
        padding: '120px 48px 80px',
        maxWidth: 1200,
        margin: '0 auto',
      }}
    >
      <GridBackground />
      <div className="relative z-10 flex flex-col text-center">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <SectionLabel>Pacific Northwest MSP + AI Automation</SectionLabel>
        </motion.div>

        <motion.h1
          className="uppercase text-center"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(52px, 8.5vw, 108px)',
            lineHeight: 0.91,
            marginBottom: 36,
            color: 'var(--white-dim)',
          }}
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Technology
        </motion.h1>
        <motion.h1
          className="uppercase text-center -mt-4"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(52px, 8.5vw, 108px)',
            lineHeight: 0.91,
            marginBottom: 36,
            color: 'var(--accent)',
          }}
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          That Just Works.
        </motion.h1>
        <motion.h1
          className="uppercase text-center -mt-4"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(52px, 8.5vw, 108px)',
            lineHeight: 0.91,
            marginBottom: 36,
            color: 'var(--white-dim)',
          }}
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          A Team Keeping
        </motion.h1>
        <motion.h1
          className="uppercase text-center -mt-4 mb-0"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(52px, 8.5vw, 108px)',
            lineHeight: 0.91,
            marginBottom: 36,
            color: 'var(--accent)',
          }}
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          You Ahead.
        </motion.h1>

        <motion.p
          className="mx-auto"
          style={{
            fontSize: 16,
            color: 'var(--white-dim)',
            maxWidth: 560,
            lineHeight: 1.7,
            marginBottom: 52,
          }}
          initial={false}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          NTC manages your entire IT environment and builds automations that give your team hours back every week — so you can focus on the work that actually grows your business.
        </motion.p>

        <motion.div
          className="flex gap-4 items-center justify-center flex-wrap"
          style={{ marginBottom: 80 }}
          initial={false}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.5 }}
        >
          <Button to="/contact" variant="primary">
            Book Your Free Discovery Call
          </Button>
          <a href="#process" className="inline-flex items-center justify-center gap-2 btn-ghost no-underline">
            See How It Works
          </a>
        </motion.div>

        <motion.div
          className="flex flex-col items-center"
          initial={false}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.5 }}
        >
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '0.22em',
              textTransform: 'uppercase',
              color: 'var(--white-dim)',
              marginBottom: 18,
            }}
          >
            Trusted Partner Of
          </span>
          <div
            className="flex gap-7 items-center flex-wrap justify-center"
            style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'var(--white-dim)',
            }}
          >
            <span>Apple Certified</span>
            <span>·</span>
            <span>AWS Certified</span>
            <span>·</span>
            <span>Microsoft 365</span>
            <span>·</span>
            <span>Google Workspace</span>
            <span>·</span>
            <span>RingCentral</span>
            <span>·</span>
            <span>Spectra Certified</span>
          </div>
        </motion.div>
      </div>
    </section>
  )
}